import { Companies_CompanyFragment } from 'generated/graphql'
import { COMPANY_TYPE_LABELS } from '../../constants/companyType'

const formatCompanyInfoCardData = (companies: Companies_CompanyFragment[]) => {
  return companies.map((company) => ({
    companyInformationId: company.companyInformation?.id || '',
    companyId: company.id,
    companyName: company.name,
    companyLogo: company.companyInformation?.thumbnailImage?.url || '',
    isHiring: company.companyInformation?.isRecruiting || false,
    isLiked: company.companyInformation?.viewerInterestedIn || false,
    companyType:
      COMPANY_TYPE_LABELS[company.companyInformation?.companyType || ''] || '',
    industryType: company.companyInformation?.companyIndustry?.secondary || '',
    likesCount: company.interestCount,
    viewsCount: company.viewCount,
  }))
}
export default formatCompanyInfoCardData
